import DogCalculator from "../../components/dogCalculatorComponents";

const DogHome = () => {
  return <DogCalculator />;
};
export default DogHome;
